import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const woocommerce = defineConnector({
  identifier: "woocommerce",
  name: "WooCommerce",
  tagLine: "WordPress e-commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "",
  auth: (app) =>
    basicAuth({
      username: app.config.consumerKey,
      password: app.secret.consumerSecret,
    }),
  steps: [
    {
      title: "Get your WooCommerce API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your WordPress admin, navigate to **WooCommerce > Settings > Advanced > REST API** and create a new API key with Read/Write permissions.",
        },
      ],
    },
    {
      title: "Enter your store details",
      items: [
        {
          kind: "url",
          label: "Store URL",
          required: true,
          placeholder: "https://yourstore.com",
          target: { kind: "configuration", field: "storeUrl" },
          helperText:
            "Your WooCommerce store URL (e.g., https://yourstore.com)",
        },
        {
          kind: "input",
          label: "Consumer key",
          required: true,
          target: { kind: "configuration", field: "consumerKey" },
          helperText: "Your WooCommerce REST API consumer key",
        },
        {
          kind: "input",
          label: "Consumer secret",
          required: true,
          target: { kind: "secrets", field: "consumerSecret" },
          helperText: "Your WooCommerce REST API consumer secret",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ storeUrl }) => `${storeUrl}/wp-json/wc/v3/system_status`,
  },
});
